import React, { useRef } from 'react';
import TabContainer from '../../components/TabContainer';
import AlisFaturalariPage from '../muhasebeLogo/AlisFaturalariPage';
import SatisFaturalariPage from '../muhasebeLogo/SatisFaturalariPage';

import MusterilerTedarikcilerPage from '../muhasebeLogo/MusterilerTedarikcilerPage';
import StokHareketleriPage from '../muhasebeLogo/StokHareketleriPage';
import GiderKalemleriPage from '../muhasebeLogo/GiderKalemleriPage';
import '../muhasebeLogo/muhasebeLogo.css';
import ZayiFirePage from '../muhasebeLogo/ZayiFirePage';
import IkramIptalPage from '../muhasebeLogo/IkramIptalPage';
import SayimHatalariPage from '../muhasebeLogo/SayimHatalariPage';

const csvCell = (value) => {
  const text = String(value ?? '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return `"${text.replace(/"/g, '""')}"`;
};

const downloadCsv = (rows, filename) => {
  const csv = rows.map(row => row.map(csvCell).join(';')).join('\r\n');
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const CsvExportWrapper = ({ children, filename }) => {
  const contentRef = useRef(null);

  const handleExport = () => {
    const root = contentRef.current;
    if (!root) return;

    const tables = Array.from(root.querySelectorAll('table'))
      .filter(table => table.offsetParent !== null);

    if (tables.length === 0) {
      window.alert('CSV olarak kaydedilecek tablo bulunamadı.');
      return;
    }

    const rows = [];
    tables.forEach((table, tableIndex) => {
      if (tableIndex > 0) rows.push([]);
      Array.from(table.querySelectorAll('tr')).forEach(tr => {
        const cells = Array.from(tr.querySelectorAll('th, td'))
          .filter(cell => cell.offsetParent !== null)
          .map(cell => cell.innerText || cell.textContent || '');
        if (cells.length > 0) rows.push(cells);
      });
    });

    if (rows.length === 0) {
      window.alert('CSV olarak kaydedilecek veri bulunamadı.');
      return;
    }

    const date = new Date().toISOString().slice(0, 10);
    downloadCsv(rows, `${filename}-${date}.csv`);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <button
          type="button"
          onClick={handleExport}
          style={{
            border: '1px solid #cfd4dc',
            background: '#fff',
            color: '#374151',
            borderRadius: 6,
            padding: '8px 13px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          ⬇ CSV Kaydet
        </button>
      </div>
      <div ref={contentRef}>{children}</div>
    </div>
  );
};

/**
 * Muhasebe-Logo
 *
 * Logo'daki muhasebe görünümünün, Toruna ERP'de zaten bulunan veriler ve
 * ekranlar kullanılarak tek bir üst menü altında toplandığı sayfa.
 * CSV çıktısı yalnızca bu Muhasebe-Logo ekranlarında gösterilir.
 */
const MuhasebeLogoPage = () => {
  const tabs = [
    {
      id: 'alis-faturalari',
      label: 'Alış Faturaları',
      icon: '🧾',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-alis-faturalari">
          <AlisFaturalariPage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'satis-faturalari',
      label: 'Satış Faturaları',
      icon: '🧾',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-satis-faturalari">
          <SatisFaturalariPage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'musteriler-tedarikciler',
      label: 'Müşteriler ve Tedarikçiler',
      icon: '👥',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-musteriler-tedarikciler">
          <MusterilerTedarikcilerPage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'stok-hareketleri',
      label: 'Stok Hareketleri',
      icon: '🔄',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-stok-hareketleri">
          <StokHareketleriPage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'gider-kalemleri',
      label: 'Gider Kalemleri',
      icon: '📝',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-gider-kalemleri">
          <GiderKalemleriPage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'zayi-fire',
      label: 'Zayi ve Fire',
      icon: '⚠️',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-zayi-fire">
          <ZayiFirePage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'ikram-iptal',
      label: 'İkram - İptal',
      icon: '🎁',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-ikram-iptal">
          <IkramIptalPage />
        </CsvExportWrapper>
      ),
    },
    {
      id: 'sayim-hatasi',
      label: 'Sayım Hataları',
      icon: '🔍',
      component: (
        <CsvExportWrapper filename="muhasebe-logo-sayim-hatalari">
          <SayimHatalariPage />
        </CsvExportWrapper>
      ),
    },
  ];

  return (
    <div className="muhasebe-logo-scope">
      <TabContainer
        title="Muhasebe-Logo"
        tabs={tabs}
        defaultTab="alis-faturalari"
        hideChildHeaders
      />
    </div>
  );
};

export default MuhasebeLogoPage;
